import {React, RouteProps, withRouter} from '@api';

interface MyProps extends RouteProps {
  roles?: string,
  allowedRoles?: Array<{}>
}

export class Authorization extends React.Component <MyProps> {
  render() {
    const {props: {component: Component, ...props}} = this;
    return <Component {...props as any} />
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/Authorization.tsx